import { Component, Input, OnChanges, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { BcRestApi } from 'common/api/rest-api';

@Component({
  selector: 'app-flag',
  templateUrl: './flag.component.html',
  styleUrls: ['./flag.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FlagComponent implements OnChanges {
  public flagState: boolean = false;
  public isFlagStateChanging: boolean = false;

  constructor(private _bcRestApi: BcRestApi, private _changeDetector: ChangeDetectorRef) {
  }

  @Input()
  workItemId: string;

  @Input()
  workItemFlagState: string;

  ngOnChanges() {
    if (!this.isFlagStateChanging) {
      this.flagState = this.workItemFlagState !== null;
    }
  }

  public setFlag(event): Promise<void> {
    event.stopPropagation();
    if (this.workItemId) {
      this.isFlagStateChanging = true;
      return this._bcRestApi.setFlag(this.workItemId, !this.flagState)
        .then(() => {
          this.isFlagStateChanging = false;
          this.flagState = !this.flagState;
          this._changeDetector.detectChanges();
        })
        .catch((err) => {
          this.isFlagStateChanging = false;
          this._changeDetector.detectChanges();
          throw new Error(err);
        });
    }
    return Promise.resolve();
  }
}
